import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, GovernmentProjectsReducer, GovernmentProjectsState } from './government-projects-reducer';
import { Pagination } from '../../../model/paginatiion';
import { IGovernmentProjectResponse } from '../../../model/base/response/government-project-response';

const GovernmentProjectsContext = createContext<GovernmentProjectsState | undefined>(undefined);
const GovernmentProjectsContextDispatchContext = createContext({} as any);

const GovernmentProjectsProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: GovernmentProjectsState = {
        projects: new Pagination<IGovernmentProjectResponse>(),
        loading: false,
    };

    const [state, dispatch] = useReducer(GovernmentProjectsReducer, initialState);

    return (
        <GovernmentProjectsContext.Provider value={state}>
            <GovernmentProjectsContextDispatchContext.Provider value={dispatch}>
                {children}
            </GovernmentProjectsContextDispatchContext.Provider>
        </GovernmentProjectsContext.Provider>
    );
}

const useGovernmentProjectsState = () => {
    const context = useContext(GovernmentProjectsContext);
    if (context === undefined) {
        throw new Error('useGovernmentProjectsState must be used within a GovernmentProjectsProvider');
    }
    return context;
}

const useGovernmentProjectsDispatch = () => {
    const context = useContext(GovernmentProjectsContextDispatchContext);
    if (context === undefined) {
        throw new Error('useGovernmentProjectsDispatch must be used within a GovernmentProjectsProvider');
    }
    return context;
}

export { GovernmentProjectsProvider, useGovernmentProjectsState, useGovernmentProjectsDispatch, ACTION_TYPES };
